<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info">{{ $t("globals.transfer_devices")  + " (" + devices.length + ")" }}:</h4>
        </b-col>
      </b-row>
      <b-row >
        <b-col>
          <!-- Table -->
          <b-row>
            <b-col>
              <b-table
                class="mt-2"
                bordered
                small
                :items="devices"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
              </b-table>
            </b-col>
          </b-row>
          <!-- Pagination -->
          <b-row>
            <b-col md="6" class="my-0">
              <b-pagination
                size="sm"
                :total-rows="devices.length"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Transfer to -->
      <hr>
      <b-row>
        <b-col>
          <b-input-group size="sm" class="my-1">
            <b-form-input
              placeholder="Order no."
              v-model="search_order_no"
              @keyup.enter="searchOrder"
              :disabled="searching"
            />
            <b-input-group-append>
              <b-btn
                variant="info"
                :disabled="searchDisabled"
                @click="searchOrder"
              >
                <v-icon v-if="searching" name="spinner" spin></v-icon>
                <v-icon v-else name="search"></v-icon>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row v-if="selected_order">
        <b-col>
          <b-form-checkbox
            class="m-1"
            v-model="def_true"
            :value="true"
            :unchecked-value="true"
            :state="true"
          >
            {{ "ID: " + selected_order.id + ", Order no.: " + selected_order.order_no + ", " + selected_order.customer.company_name }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <!-- Sold option -->
      <b-row>
        <b-col>
          <b-form-checkbox
            class="m-1"
            v-model="sold"
            :value="true"
            :unchecked-value="false"
            :state="sold ? sold : null"
          >
            {{ $t("globals.add_a_sold_event_for_these_devices") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="sold">
        <b-col cols="12">
          <b-form-checkbox
            class="m-1"
            v-model="sold_lease"
            :value="true"
            :unchecked-value="false"
          >
            {{ $t("globals.lease") }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <span>{{ $t("globals.sold_at") }}:</span>
          <b-form-datepicker 
            :state="true"
            v-model="sold_at"
          ></b-form-datepicker>
        </b-col>
        <b-col v-if="this.getUserBrandPermissions.super_admin" cols="12">
          <span v-b-tooltip.hover title="Optional, if left empty, you will be assigned" >
            {{ "*" + $t("globals.select_agent") }}:
          </span>
          <b-form-select
            class="m-1"
            v-model="new_agent_id"
            :options="agentOptions"
          />
        </b-col>
      </b-row>
      <!-- Actions -->
      <hr />
      <b-row>
        <b-col>
          <b-btn
            class="float-right m-1"
            @click="submit"
            variant="success"
            :disabled="submitDisabled"
          >
            {{ $t("globals.submit") }}
          </b-btn>
          <b-btn
            class="m-1"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    devices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      def_true: true,
      sold: false,
      sold_lease: false,
      sold_at: "",
      perPage: 10,
      search_order_no: null,
      searching: false,
      selected_order: null,
      currentPage: 1,
      new_agent_id: null,
      agentOptions: [],
      fields: [
        {
          key: "id",
          label: "ID"
        },
        {
          key: "imei",
          label: "IMEI"
        },
        {
          key: "product",
          label: this.$t("globals.product")
        },
        {
          key: "batch",
          label: this.$t("globals.batch")
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", {
      simpleMutation: "simpleMutation",
      simpleFetch: "simpleFetch",
      fetchAgentsFromStore: "fetchAgents"
    }),
    submit() {
      const device_list = this.devices.map(a => a.imei);

      let data = {
          query: `
            mutation DevicesTransfer (
              $device_list: [String],
              $old_order_id: ID,
              $new_order_id: ID,
              $sold: Boolean,
              $sold_lease: Boolean,
              $sold_at: String,
              $agent_id: ID
            ) { 
              res: DevicesTransfer (
                device_list: $device_list,
                old_order_id: $old_order_id,
                new_order_id: $new_order_id,
                sold: $sold,
                sold_lease: $sold_lease,
                sold_at: $sold_at,
                agent_id: $agent_id
              )
            }
          `,
          variables: {
            device_list: device_list,
            old_order_id: parseInt(this.$route.params.id),
            new_order_id: parseInt(this.selected_order.id),
            sold: this.sold,
            sold_lease: this.sold_lease,
            sold_at: this.sold_at,
            agent_id: this.new_agent_id
          }
        };

        this.simpleMutation({ data, this_ref: this }).then(() => {
          this.cancelModal();
        });
    },
    searchOrder() {
      if (this.searchDisabled) {
        return false;
      }

      const data = {
        query: `
          query  {
            OrderByOrderNo (order_no: ${this.search_order_no}) {
              id
              order_no
              customer {
                company_name
              }
            }
          }
        `
      };
      this.searching = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.selected_order = res.OrderByOrderNo;
        }
      }).finally(()=>{
        this.searching = false;
      });
    },
    loadAgents() {
      this.fetchAgentsFromStore({ this_ref: this }).then(res => {
        if (res) {
          this.agentOptions = res;
        }
      });
    },
    cancelModal() {
      this.filter = null,
      this.sold = false;
      this.sold_lease = false;
      this.search_order_no = null;
      this.selected_order = null;
      this.new_agent_id = null;

      this.setToday();
      this.close();
    },
    setToday() {
      const now = new Date;
      this.sold_at = now.toISOString().substring(0,10);
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    noSelectedDevices() {
      return this.devices.filter(e => e.selected).length
    },
    submitDisabled() {
      return this.selected_order == null
    },
    searchDisabled() {
      return (
        this.search_order_no == null || this.search_order_no == ''
      )
    }
  },
  mounted() {
    this.setToday();
    this.loadAgents();
  }
};
</script>
